// extracted by mini-css-extract-plugin
export var infoRow = "_r0-2";
export var labelContainer = "_r0-0";
export var rightInfo = "_r0-1";